(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PrefectureSearch', PrefectureSearch);

    PrefectureSearch.$inject = ['$resource'];

    function PrefectureSearch($resource) {
        var resourceUrl =  'api/_search/prefectures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
